"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailAccountAuthStrategy = void 0;
var MailAccountAuthStrategy;
(function (MailAccountAuthStrategy) {
    MailAccountAuthStrategy["Basic"] = "Basic";
    MailAccountAuthStrategy["BasicMicrosoft"] = "BasicMicrosoft";
    MailAccountAuthStrategy["BasicGoogle"] = "BasicGoogle";
    MailAccountAuthStrategy["XOauth2Microsoft"] = "XOauth2Microsoft";
    MailAccountAuthStrategy["XOauth2Google"] = "XOauth2Google";
})(MailAccountAuthStrategy = exports.MailAccountAuthStrategy || (exports.MailAccountAuthStrategy = {}));
